module.exports = __webpack_public_path__ + "static/media/globalsped_logo.17040821.jpg";